module.exports = __webpack_public_path__ + "static/media/snail-highlight.a3b6522b.svg";